'use strict';

(function () {
  if (customElements.get('upqode-location-slider')) return;

  class UpqodeLocationSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.slider = this.querySelector('.swiper');
      this.paginationEl = this.querySelector('.swiper-pagination');
    }

    connectedCallback() {
      if (!this.slider) return;
      this.initSwiper();
    }

    initSwiper() {
      let { spaceBetween = '16', spaceBetweenPc = '24' } = this.dataset;
      spaceBetween = Number(spaceBetween);
      spaceBetweenPc = Number(spaceBetweenPc);

      const pagination = this.paginationEl
        ? {
            el: this.paginationEl,
            clickable: true,
          }
        : false;

      this.swiper = new Swiper(this.slider, {
        slidesPerView: 1,
        spaceBetween: spaceBetween,
        grabCursor: true,
        watchOverflow: true,
        slidesPerGroup: 1,
        centeredSlides: false,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        navigation: false,
        pagination,
        breakpoints: {
          640: {
            spaceBetween: spaceBetween,
          },
          1024: {
            spaceBetween: spaceBetweenPc,
          },
        },
      });
    }
  }

  customElements.define('upqode-location-slider', UpqodeLocationSlider);
})();
